import React from "react";
var __jsx = React.createElement;
import { Tooltip, UnstyledButton } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useOpenStudy } from "@/hooks/viewer";
import { DicomGlyph } from "./dicom-glyph";
import { DicomLinkMenu } from "./dicom-link-menu";
/** DICOM badge for a report: opens the viewer when a study is linked, otherwise offers linking. */
export function DicomBadge(_ref) {
  var reportId = _ref.reportId,
    studyId = _ref.studyId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var openStudy = useOpenStudy();
  if (studyId == null) {
    return /*#__PURE__*/React.createElement(DicomLinkMenu, {
      reportId: reportId
    });
  }
  var label = t("open_dicom_images", {
    defaultValue: "Open DICOM images"
  });
  return /*#__PURE__*/React.createElement(Tooltip, {
    label: label,
    position: "bottom",
    withArrow: true,
    withinPortal: true
  }, /*#__PURE__*/React.createElement(UnstyledButton, {
    type: "button",
    "data-testid": "report-dicom-open-".concat(reportId),
    "aria-label": label,
    onClick: function onClick(event) {
      event.stopPropagation();
      openStudy(studyId);
    },
    className: "inline-flex flex-shrink-0 items-center gap-1 rounded-sds-100 border border-teal-600 bg-teal-50 px-1.5 py-0.5 text-style-label-caps text-teal-600 hover:bg-teal-500/10 dark:border-teal-500 dark:bg-teal-950 dark:text-teal-400 dark:hover:bg-teal-900"
  }, /*#__PURE__*/React.createElement(DicomGlyph, {
    className: "h-2.5 w-2.5 flex-shrink-0"
  }), t("dicom", {
    defaultValue: "DICOM"
  })));
}